module.exports = __webpack_public_path__ + "static/media/Privacy.68743958.md";